<div class="drill-down-container" *ngIf="config.show">
    <div class="header">
        <div class="h2-regular text-ellipsis" kendoTooltip tamDynamicTooltip [title]="config.name" position="bottom">
            {{config.name}}
        </div>
        <div class="btn-box">
            <smart-icon name='refresh' class="light" (click)="refreshClick()"></smart-icon>
            <smart-icon name='close' class="light" (click)="closeClick()"></smart-icon>
        </div>
    </div>
    <div class="body">
        <div [style.width]='(config.style.cols / 6)*100 + "%"' [style.height]='config.style.rows * 150 + "px"'
            [class.no-data]="noData">
            <div class="no-data-box-div" *ngIf="noData">
                <span class="no-data-box">
                    There is no data available.
                </span>
            </div>
            <ng-template tamDashboardTileContainer></ng-template>
        </div>
        <div class="grid-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
            <div class="total grid-toolbar">
                <span class="body-1">Show {{total}} results</span>
                <smart-icon name="export-excel" (click)="exportToExcel()" class="light export-icon" kendoTooltip
                    position="left" title="{{'general.export_to_excel' | stringLiterals}}" *ngIf="total"></smart-icon>
            </div>
            <div class="grid">
                <ag-grid-angular class="ag-theme-balham grid-table" [columnDefs]="columnDefs"
                    [excelStyles]="excelStyles" [gridOptions]="gridOptions" [rowData]="gridData"
                    (gridReady)="onGridReady($event)" [components]="frameworkComponents">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>